import React from "react";
import {Col, Row} from "../Grid";
import "./Footer.css";
import { useThemeMode } from '../../utils/useThemeMode';

const StickyFooter = () => {
  const { mode } = useThemeMode();
  
  // Dynamic styles based on theme
  const footerStyle = {
    backgroundColor: mode === 'dark' ? '#000000' : '#F4F4F4',
    color: mode === 'dark' ? 'rgba(255, 255, 255, 0.87)' : 'inherit',
  };
  
  // Style for GitHub links
  const linkStyle = {
    textDecoration: 'none',
    fontWeight: 'bold',
  };

  return (
    <Row 
      className="justify-content-center footer sticky-footer p-0"
      style={footerStyle}
    >
      <Col size="12 col-md-10" className="pt-3">
        <p className="text-center font-italic footer-text">
          Made with <i className="fas fa-heart"></i> by {' '}
          <a href="https://github.com/robertshaw87" style={linkStyle} target="_blank" rel="noopener noreferrer">Robert</a>, {' '}
          <a href="https://github.com/EricNg314" style={linkStyle} target="_blank" rel="noopener noreferrer">Eric</a>, {' '}
          <a href="https://github.com/Unobtainiumrock" style={linkStyle} target="_blank" rel="noopener noreferrer">Nick</a> {' '} 
          &amp; <a href="https://github.com/jimmytutron" style={linkStyle} target="_blank" rel="noopener noreferrer">Jimmy</a>
        </p>
      </Col>
    </Row>
  );
};

export {StickyFooter};
